import { useNavigate } from "react-router-dom";

const UserGroupsNavigation = (userId) => {
  const navigate = useNavigate();

  const goToUserGroups = () => {
    if (!userId) {
      console.warn("⚠️ userId not set yet — navigation aborted.");
      return;
    }
    navigate(`/user-groups/${userId}`);
  };

  return { goToUserGroups }; // ✅ Return an object
};

export default UserGroupsNavigation;